import { find } from 'lodash';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { LegacyCustomer } from '@pos/app/scripts/services/legacy-consumer';

/*
 * Displays information about retail consumers when a consumer object is provided
 */
angular.module('posApp').component('customerCard', {
  template: require('./customer-card.html').default,
  bindings: {
    customer: '=',
  },

  controller: function (
    legacyCustomer: LegacyCustomer,
    loadCustomerInfo,
    navigateTo: NavigateTo,
    pos,
  ) {
    const $ctrl = this;

    $ctrl.$onInit = () => {
      $ctrl.openRemark = false;
    };

    $ctrl.toggleRemarkPopup = () => {
      $ctrl.openRemark = !$ctrl.openRemark;
    };

    $ctrl.showCustomerInfo = () => {
      if (
        pos.transaction &&
        pos.transaction.customer &&
        pos.transaction.customer.id
      ) {
        loadCustomerInfo('pos.route#pos');
        navigateTo('pos.route#customer-info/' + pos.transaction.customer.id);
      }
    };

    function getPrimaryAddress(customer) {
      if (customer?.addresses?.length) {
        let primary = find(customer.addresses, { primary: true });
        if (primary) {
          if (primary.houseno) {
            return `${primary.street} ${primary.houseno}${primary.houseadd} ${primary.city}`;
          } else {
            return `${primary.street} ${primary.city}`;
          }
        }
      } else {
        return '';
      }
    }

    $ctrl.$onChanges = () => {
      $ctrl.openRemark = false;

      if (angular.isObject($ctrl.customer)) {
        legacyCustomer.get($ctrl.customer.id).then((customerEntity) => {
          $ctrl.customerAddress = getPrimaryAddress(customerEntity);

          if (customerEntity?.remarks) {
            $ctrl.customerShortRemarks = angular.isString(
              customerEntity.remarks,
            )
              ? customerEntity.remarks.substring(0, 100)
              : '';
            $ctrl.customerLongRemarks = angular.isString(customerEntity.remarks)
              ? customerEntity.remarks.substring(0, 512)
              : '';
            $ctrl.showEllipses = customerEntity.remarks.length > 100;
          } else {
            $ctrl.customerShortRemarks = '';
            $ctrl.customerLongRemarks = '';
            $ctrl.showEllipses = false;
          }
        });
      } else {
        $ctrl.customerShortRemarks = '';
        $ctrl.customerLongRemarks = '';
        $ctrl.showEllipses = false;
      }
    };
  },
});
